<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7803 6.71967C17.0732 7.01256 17.0732 7.48744 16.7803 7.78033L10.5303 14.0303C10.2374 14.3232 9.76256 14.3232 9.46967 14.0303L3.22162 7.78228C2.92873 7.48939 2.92873 7.01452 3.22162 6.72162C3.51452 6.42873 3.98939 6.42873 4.28228 6.72162L10 12.4393L15.7197 6.71967C16.0126 6.42678 16.4874 6.42678 16.7803 6.71967Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
